import React from 'react';
import LoadingSkeleton from "../../cmp/LoadingSkeleton";

const Page = React.lazy(()=>import('./AmbassadorLocator_Internal'))

export default function AmbassadorLocator(){
    return <React.Suspense fallback={<LoadingSkeleton height={500} />}>
        <Page />
    </React.Suspense>
}
